import { render, staticRenderFns } from "./GroupSessionAttendanceCanceledNotification.vue?vue&type=template&id=09c163be&scoped=true&"
import script from "./GroupSessionAttendanceCanceledNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionAttendanceCanceledNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c163be",
  null
  
)

export default component.exports